import apiRequestService from '@/commonProject/service/apiRequestService';

export default class setupUserRepository {
    /**
     * ユーザー親権者同意情報設定APIをコールする。
     * @param {Object} requestBody
     * @returns result
     */
    async putUserParentActionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPut(API_URL + '/usrpar', requestBody, idToken);
        return result;
    }
}
